__turbopack_context__.v({
  "cta": "MobileEditBlock-module__1g74AG__cta",
  "description": "MobileEditBlock-module__1g74AG__description",
  "text": "MobileEditBlock-module__1g74AG__text",
  "textBlock": "MobileEditBlock-module__1g74AG__textBlock",
  "title": "MobileEditBlock-module__1g74AG__title",
});
